import * as Common from "@tfo/common"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { IndividualViewStore } from "../stores/IndividualViewStore"

type CapRootStore = {
	individualViewStore: {
		reportStore: {
			fetchOrder: (number) => void
		}
	}
	login: (cookie?: string) => Promise<void>
}

export function useReportStoreBackoffice<T extends CapRootStore>(): [IndividualViewStore, (cookieData: string) => void] {
    const { individualViewStore, login } = Common.hooks.useStore<T>()
    const { orderId } = useParams<{ orderId: string }>()
    const [ cookieReady, setCookieReady] = useState(false);
    const [ fetchOrder, setfetchOrder] = useState(true);

    useEffect(() => {
        if (orderId && (window as any).tfoToken ) {
            // Only call fetchOrder one time or you will get 'Error: Maximum update depth exceeded.'
            login(); // Init reportStore?
            if (fetchOrder) {
                setfetchOrder(false)
                individualViewStore.reportStore.fetchOrder(Number(orderId))
            }
        }
    }, [orderId, cookieReady])

    const setCookieData = (cookieData: string) => {
        const cookie = JSON.parse(cookieData);
        (window as any).tfoToken = cookie.token;
        setCookieReady(true) // Will trigger fetchOrder in useEffect if not already run
    }

    return [individualViewStore as IndividualViewStore, setCookieData]
}
